import AccessTokensPanel from '../../components/AccessTokens/AccessTokensPanel';
import styles from './AccessTokensPage.module.css';

export default function AccessTokensPage() {
  return (
    <div className={styles.page}>
      <AccessTokensPanel />
    </div>
  );
}
